import { getOpenReplayTracker } from '@blueberry/observability/open_replay'
import { trackEvent } from './track_event'

const dotPhraseUsed = (opts: {
  hashedCaseId: number
  phrase: string
  section: string
}) => {
  return trackEvent('Dot phrase used', 'DOCTOR_EXPERIENCE', {
    hashed_case_id: opts.hashedCaseId,
    phrase: opts.phrase,
    section: opts.section,
  })
}

const chatMessageSubmitted = (opts: {
  hashedCaseId: number
  hashedMessageToId: number
}) => {
  return trackEvent('Chat message submitted', 'DOCTOR_EXPERIENCE', {
    hashed_case_id: opts.hashedCaseId,
    hashed_message_to_id: opts.hashedMessageToId,
  })
}

const hpiSummaryCopiedIntoPrivateDoctorNote = (opts: { caseId: number }) => {
  return trackEvent(
    'History of Present Illness summary copied into Private Doctor Note',
    'DOCTOR_EXPERIENCE',
    { case_id: opts.caseId },
  )
}

const apRecommendationsExposedToDoctor = (opts: {
  caseId: number
  recommendationsCount: number
  templateDotPhraseIds: number[]
}) => {
  return trackEvent(
    'A/P recommendations exposed to doctor',
    'DOCTOR_EXPERIENCE',
    {
      case_id: opts.caseId,
      recommendations_count: opts.recommendationsCount,
      template_dot_phrase_ids: opts.templateDotPhraseIds,
    },
  )
}

const apRecommendationAcceptedByDoctor = (opts: {
  caseId: number
  templateDotPhraseId: number
}) => {
  return trackEvent(
    'A/P recommendation accepted by doctor',
    'DOCTOR_EXPERIENCE',
    { case_id: opts.caseId, template_dot_phrase_id: opts.templateDotPhraseId },
  )
}

const webSocketConnectionClosed = (opts: {
  ws_url: string
  code: number
  reason: string
  wasClean: boolean
}) => {
  return trackEvent('Websocket Connection Closed', 'DOCTOR_EXPERIENCE', {
    ws_url: opts.ws_url,
    code: opts.code,
    reason: opts.reason,
    was_clean: opts.wasClean,
  })
}

const networkBackOnline = () => {
  return trackEvent('Network back online', 'DOCTOR_EXPERIENCE', {
    open_replay_session_id: getOpenReplayTracker()?.sessionID(),
  })
}

const automatedOutreachModalOpened = (opts: { caseId: number }) => {
  return trackEvent('Automated outreach modal opened', 'DOCTOR_EXPERIENCE', {
    case_id: opts.caseId,
  })
}

const automatedOutreachModalDismissed = (opts: { caseId: number }) => {
  return trackEvent('Automated outreach modal dismissed', 'DOCTOR_EXPERIENCE', {
    case_id: opts.caseId,
  })
}

const parentNoteTemplateSelected = (opts: {
  caseId: number
  searchableTitle: string
  diagnosis: string
  treatment: string
}) => {
  return trackEvent('Parent note template selected', 'DOCTOR_EXPERIENCE', {
    case_id: opts.caseId,
    searchable_title: opts.searchableTitle,
    diagnosis: opts.diagnosis,
    treatment: opts.treatment,
  })
}

export const TrackDxEvent = {
  automatedOutreachModalDismissed,
  automatedOutreachModalOpened,
  chatMessageSubmitted,
  dotPhraseUsed,
  hpiSummaryCopiedIntoPrivateDoctorNote,
  apRecommendationsExposedToDoctor,
  apRecommendationAcceptedByDoctor,
  webSocketConnectionClosed,
  networkBackOnline,
  parentNoteTemplateSelected,
}
